import { createSelector } from '@reduxjs/toolkit';
import type { AppState } from '@src/providers/AppStateProvider/types';
import type { OptionMarketTabData } from '../../../../../providers/MarketTabs.types';
import { DEFAULT_OPTION_COLUMNS_IS_VISIBLE } from '../types';

export const selectOptionMarketSelected = (state: AppState, id: string): string | undefined =>
  state.optionsTab.panels[id]?.optionFilter.market;
export const selectOptionFilter = (state: AppState, id: string) => state.optionsTab.panels[id]?.optionFilter;
export const selectMeta = (state: AppState) => state.optionsTab.meta;
export const selectStrikeFilter = (state: AppState, id: string) => state.optionsTab.panels[id]?.strikeFilter;
export const selectLoading = (state: AppState, id: string) => state.optionsTab.panels[id]?.loading;
export const selectUnderlyingAmount = (state: AppState, id: string) =>
  state.optionsTab.panels[id]?.underlyingAmountByExpiry;
export const selectColumnVisibility = (state: AppState, id: string) =>
  state.optionsTab.panels[id]?.columnDefsVisibility || DEFAULT_OPTION_COLUMNS_IS_VISIBLE;
export const selectOptionDataError = (state: AppState, id: string) => state.optionsTab.panels[id]?.error;

export const selectTabData = createSelector(
  selectStrikeFilter,
  selectOptionFilter,
  selectColumnVisibility,
  (strikeFilter, optionFilter, columnDefsVisibility) =>
    ({
      strikeFilter,
      optionFilter,
      columnDefsVisibility,
      type: 'options',
    }) satisfies OptionMarketTabData & { type: 'options' }
);
